import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import CompositionFilterCriteria from './CompositionFilterCriteria'
import CompositionList from './CompositionList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './CompositionAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCompositionDashboardCompositionList } from '../../store/slice/PharmaSlice';

export default function CompositionListView({setShowEdit,setCompositionId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.compositionDashboard);   

    const [filteredCompositionList, setFilteredCompositionList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { compositionDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (compositionDashboard.compositionList.length>-1){
        setFilteredCompositionList(compositionDashboard.compositionList);
        transformToCardFormat(compositionDashboard.compositionList, setCardList);
      }
    },[compositionDashboard.compositionList])

    useEffect(()=>{
          transformToCardFormat(filteredCompositionList, setCardList);
      },[filteredCompositionList])

    useEffect(()=>{
        if (filterCriteria.name==='' ){
            setFilteredCompositionList(compositionDashboard.compositionList);
            transformToCardFormat(compositionDashboard.compositionList, setCardList);

        } else {
            setFilteredCompositionList(
                compositionDashboard.compositionList
                    .filter(composition=> composition.name.toString().toUpperCase().includes(filterCriteria.name.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(compositionDashboard.filteredCompositionList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <CompositionList
                    setShowEdit={setShowEdit}
                    setCompositionId = {setCompositionId}
                    tableList={filteredCompositionList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}